import React, {Component} from 'react';
import {Switch, Route, BrowserRouter} from 'react-router-dom';
import {Provider} from 'mobx-react';

import Calculator from './views/Calculator'
import About from './views/About'
import Terms from './views/Terms'
import News from './views/News'
import Cookies from './views/Cookies'
import Menu from './components/Menu';
import Footer from './components/Footer'
import Newsletter from './components/Newsletter';
import store from './store/store'

import ModalDialog from './components/ModalDialog'
import ScrollToTop from './components/ScrollToTop';

export default class App extends Component {
    render() {
        const {
            isApp
        } = this.props;
        return (
            <Provider store={store}>
                <BrowserRouter>
                    <ScrollToTop>
                        <div className={isApp ? 'app' : ''}>
                            {!isApp &&
                            <Menu/>
                            }
                            <Switch>
                                <Route exact path='/' component={Calculator}/>
                                <Route path='/about' component={About}/>
                                <Route path='/terms' component={Terms}/>
                            </Switch>

                            <Newsletter/>
                            <Footer isApp={isApp}/>

                            <ModalDialog/>

                        </div>
                    </ScrollToTop>
                </BrowserRouter>
            </Provider>
        );
    }
}


// WEBPACK FOOTER //
// ./src/App.js